import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import EditorPage from "../editor/EditorPage";
import SignIn from "../layouts/sign-in/SignIn";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("access_token");

  return token ? children : <Navigate to="/sign-in" />;
}

export default function AppRoutes() {
    return (
      <BrowserRouter>
        <Routes>
            <Route path="/sign-in" element={<SignIn />} />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route path="/editor/:jobId" element={<EditorPage />} />
        </Routes>
      </BrowserRouter>
    );
}